// State
export const state = () => ({
	loading: false,
	licenses: [],
	license: {}
})

// Actions
export const actions = {
	async licenses({ commit }) {
		try {
			commit('loading', true)
			await this.$axios
				.get(`/approved-license`)
				.then((response) => {
					commit('setLicenses', response.data.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	},
	async license({ commit }, id) {
		try {
			commit('loading', true)
			await this.$axios
				.get(`/approved-license/${id}`)
				.then((response) => {
					commit('setLicense', response.data.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	},
	async deleteLicense({ commit, dispatch }, id) {
		try {
			commit('loading', true)
			const response = await this.$axios
				.delete(`/approved-license/${id}`)
				.then((response) => {
					commit('loading', false)
					dispatch('licenses')
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
	async createLicense({ commit }, data) {
		try {
			const formData = new FormData()
			for (const key in data) {
				if (key === 'title') {
					formData.append(key, JSON.stringify(data[key]));
				} else {
					formData.append(key, data[key]);
				}
			}
			commit('loading', true)
			const response = await this.$axios
				.post(`/approved-license`, formData)
				.then(async (response) => {
					commit('loading', false)
					const resData = response.data
					const message = await this.dispatch(
						'language-strings/tl',
						resData?.message
					)
					this.$toast.success(message)
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
	async updateLicense({ commit }, form) {
		const data = { ...form }
		const { id } = data
		delete data.id
		const formData = new FormData()
		for (const key in data) {
			if (key === 'title') {
				formData.append(key, JSON.stringify(data[key]));
			} else {
				formData.append(key, data[key]);
			}
		}
		try {
			commit('loading', true)
			const response = await this.$axios
				.put(`/approved-license/${id}`, formData)
				.then((response) => {
					commit('loading', false)
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
	async updateSequence({ commit }, form) {
		const data = [...form]
		try {
			commit('loading', true)
			const response = await this.$axios
				.put(`/approved-license/bulk-sequence`, data)
				.then(async (response) => {
					commit('loading', false)
					const resData = response.data
					const message = await this.dispatch(
						'language-strings/tl',
						resData?.message
					)
					this.$toast.success(message)
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
}


// Mutations
export const mutations = {
	loading(state, type) {
		state.loading = type
	},
	setLicenses(state, data) {
		state.licenses = data
	},
	setLicense(state, data) {
		state.license = data
	}
}

// Getters
export const getters = {}